module.exports = __webpack_public_path__ + "static/img/手办.2157be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/手办.png
// module id = lPu7
// module chunks = 1